<template>
    <div class="pages crowdMarketing">
        <div class="title mb-30">
            <p>
                <img src="../../assets/images/newIcon/group_recommend_icon.png" alt="">
                <span>推荐分组</span>
            </p>
            <p>
            </p>
        </div>
        <div class="f2 mb-30">
            <div class="li">
                <div>
                    <p>新客户入群</p>
                    <p>近7天内加入，但未消费的顾客</p>
                </div>
                <div>
                    <p>
                        <span>19,999</span>
                        <span>人数总数</span>
                    </p>
                    <p>
                        <span>19,999</span>
                        <span>昨日访问</span>
                    </p>
                </div>
                <div class="foot_btn" @click="newPlan">
                    <p>
                        <img src="../../assets/images/newIcon/vip_groupjingying_icon.png" alt="">
                        <span>创建运营计划</span>
                    </p>
                </div>
            </div>
            <div class="li">
                <div>
                    <p>潜在客户</p>
                    <p>近30天内加入，3次登录，但未消费的顾客</p>
                </div>
                <div>
                    <p>
                        <span>19,999</span>
                        <span>人数总数</span>
                    </p>
                    <p>
                        <span>19,999</span>
                        <span>昨日访问</span>
                    </p>
                </div>
                <div class="foot_btn" @click="newPlan">
                    <p>
                        <img src="../../assets/images/newIcon/vip_groupjingying_icon.png" alt="">
                        <span>创建运营计划</span>
                    </p>
                </div>
            </div>
            <div class="li">
                <div>
                    <p>活跃客户</p>
                    <p>近30天内有购买的客户</p>
                </div>
                <div>
                    <p>
                        <span>19,999</span>
                        <span>人数总数</span>
                    </p>
                    <p>
                        <span>19,999</span>
                        <span>昨日访问</span>
                    </p>
                </div>
                <div class="foot_btn" @click="newPlan">
                    <p>
                        <img src="../../assets/images/newIcon/vip_groupjingying_icon.png" alt="">
                        <span>创建运营计划</span>
                    </p>
                </div>
            </div>
            <div class="li">
                <div>
                    <p>忠实客户</p>
                    <p>消费次数超过3次的客户</p>
                </div>
                <div>
                    <p>
                        <span>19,999</span>
                        <span>人数总数</span>
                    </p>
                    <p>
                        <span>19,999</span>
                        <span>昨日访问</span>
                    </p>
                </div>
                <div class="foot_btn" @click="newPlan">
                    <p>
                        <img src="../../assets/images/newIcon/vip_groupjingying_icon.png" alt="">
                        <span>创建运营计划</span>
                    </p>
                </div>
            </div>
            <div class="li">
                <div>
                    <p>沉睡客户</p>
                    <p>超过90天未登录的客户</p>
                </div>
                <div>
                    <p>
                        <span>19,999</span>
                        <span>人数总数</span>
                    </p>
                    <p>
                        <span>19,999</span>
                        <span>昨日访问</span>
                    </p>
                </div>
                <div class="foot_btn" @click="newPlan">
                    <p>
                        <img src="../../assets/images/newIcon/vip_groupjingying_icon.png" alt="">
                        <span>创建运营计划</span>
                    </p>
                </div>
            </div>
        </div>
        <div class="f3">
            <el-form :inline="true" label-width="100px" :model="query" class="demo-form-inline">
                <el-row :gutter="20">
                    <el-col :span="6">
                        <el-form-item class="formItem" label="会员分组：">
                            <span @click="showFz(2)">
                                <el-input
                                class="iptRdio"
                                placeholder="请选择会员分组"
                                    suffix-icon="el-icon-arrow-down"
                                v-model="query.keyword_search"
                                ></el-input>
                            </span>
                            
                        </el-form-item>
                    </el-col>
                    <el-col :span="7">
                        <el-form-item class="formItem formItem2" label="状态筛选：">
                            <el-select class="iptRdio" v-model="value" placeholder="请选择状态">
                                <el-option
                                v-for="item in options"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="7">
                        <el-form-item class="formItem formItem2" label="计划筛选：">
                            <el-select class="iptRdio" v-model="value2"  placeholder="请选择计划类型">
                                <el-option
                                v-for="item in options2"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="3">
                        <div style="text-align: right;">
                            <el-button  class="reson" type="primary" round icon="el-icon-refresh-right">重置</el-button>
                            <el-button type="text" v-if="types==2" @click="types=1">收起 <i class="el-icon-arrow-up icons"></i></el-button>
                            <el-button type="text" v-if="types==1" @click="types=2">展开 <i class="el-icon-arrow-down icons"></i></el-button>
                        </div>
                    </el-col>
                </el-row>
                <el-row :gutter="20" v-show="types==2">
                    <el-col :span="6">
                        <el-form-item class="formItem" label="通知渠道：">
                            <el-select class="iptRdio" v-model="value3" placeholder="请选择渠道">
                                <el-option
                                v-for="item in options3"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value">
                                </el-option>
                            </el-select>
                            
                        </el-form-item>
                    </el-col>
                    <el-col :span="7">
                        <el-form-item class="formItem formItem2" label="业务系统：">
                            <el-select class="iptRdio" v-model="value4" placeholder="请选择业务系统">
                                <el-option
                                v-for="item in options4"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="7">
                            <el-form-item class="formItem formItem2" label="">
                        </el-form-item>
                    </el-col>
                    <el-col :span="3">
                        <div style="text-align: right;">
                                <el-button @click="newPlan"  class="reson" type="primary" round><img src="../../assets/images/newIcon/croedmarket_add_icon2.png" style="width:16px;height:16px;vertical-align: middle;" alt=""> 新增营销计划</el-button>
                        </div>
                    </el-col>
                </el-row>
            </el-form>
            <el-table
                :data="tableData3"
                :header-cell-style="{background:'#EEEEEE',textAlign:'center',fontSize:'12px'}"
                style="width: 100%;"
                :cell-style="{textAlign:'center',fontSize:'12px'}"
                >
                <el-table-column
                prop="name"
                label="计划名称"
                >
                </el-table-column>
                <el-table-column
                prop="number"
                show-overflow-tooltip
                label="人群名称"
                >
                </el-table-column>
                <el-table-column
                prop="xmember"
                label="类型"
                cell-style="background:red;"
                >
                </el-table-column>
                <el-table-column
                prop="lmember"
                label="业务系统"
               >
                </el-table-column>
                <el-table-column
                prop="labellv"
                label="营销渠道"
                >
                </el-table-column>
                <el-table-column
                prop="names"
                label="状态"
                >
                </el-table-column>
                <el-table-column
                prop="times"
                label="时间"
                >
                </el-table-column>
                <el-table-column
                prop="labellv"
                label="操作"
                width="240"
                >
                    <template slot-scope="scope">
                        <el-button type="text" @click="goReport">数据报表</el-button>
                        <el-button type="text" @click="goDetail">详情</el-button>
                        <el-button type="text" @click="showFz(1)">复制</el-button>
                        <el-button type="text" @click="del">删除</el-button>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <div class="page">
            <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            style="margin-top: 24px;"
            :current-page="query.page_index"
            :page-sizes="[10, 20, 30, 40]"
            :page-size="query.page_size"
            layout="prev, pager, next, sizes, jumper"
            :total="total"
            ></el-pagination>
        </div>
        <memberGroup ref="memberGroup" @do="copyGroup"></memberGroup>
    </div>
</template>
<script>
const QUERY={
    keyword_search:"",
    page_index: 1,
    page_size: 10,
}
import memberGroup from './components/memberGroup'
export default {
    data() {
        return {
            types:2,
            query:JSON.parse(JSON.stringify(QUERY)),
            time:"",
            total:100,
            options: [{
            value: '选项1',
            label: '待开始'
            }, {
            value: '选项2',
            label: '执行中'
            }, {
            value: '选项2',
            label: '已完成'
            }],
            options2: [{
            value: '选项1',
            label: '长期计划'
            }, {
            value: '选项2',
            label: '单次计划'
            }],
            options4: [{
            value: '选项1',
            label: '颐安中台'
            }, {
            value: '选项2',
            label: '小橘帮帮'
            }],
            options3: [ {
            value: '',
            label: '公众号通知'
            }, {
            value: '选项2',
            label: 'push通知'
            }, {
            value: '选项2',
            label: '弹窗推送'
            }],
            value: '',
            value2: '',
            value3: '',
            value4: '',
            tableData: [{
                id:1,
                name: '新客户人群',
                number:"新客户人群",
                xmember:"近90天有访问店铺，近90天有访问店铺",
                lmember:"100"
            },{
                id:2,
                name: '新客户人群',
                number:"新客户人群",
                xmember:"近90天有访问店铺，近90天有访问店铺",
                lmember:"100"
            },{
                id:3,
                name: '新客户人群',
                number:"新客户人群",
                xmember:"近90天有访问店铺，近90天有访问店铺",
                lmember:"100"
            },{
                id:4,
                name: '新客户人群',
                number:"新客户人群",
                xmember:"近90天有访问店铺，近90天有访问店铺",
                lmember:"100"
            },],
            tableData3: [{
                name: '赠送活动',
                number:"活跃人群",
                xmember:"单次计划",
                lmember:"颐安中台",
                labellv:"短信通知",
                names:"待开始",
                times:"2021	.10.12 18:00",
                },{
                name: '赠送活动',
                number:"新客户人群",
                xmember:"长期计划",
                lmember:"颐安中台",
                labellv:"公众号通知",
                names:"执行中",
                times:"2021	.10.12 18:00",
                },{
                name: '赠送活动',
                number:"潜在客户人群",
                xmember:"单次计划",
                lmember:"小橘帮帮",
                labellv:"push推送",
                names:"待开始",
                times:"2021	.10.12 18:00",
                },{
                name: '赠送活动',
                number:"忠实客户人群",
                xmember:"单次计划",
                lmember:"小橘帮帮",
                labellv:"短信通知",
                names:"待开始",
                times:"2021	.10.12 18:00",
                },{
                name: '赠送活动',
                number:"高消费人群",
                xmember:"单次计划",
                lmember:"小橘帮帮",
                labellv:"短信通知",
                names:"待开始",
                times:"2021	.10.12 18:00",
                },{
                name: '赠送活动',
                number:"人群名称1",
                xmember:"单次计划",
                lmember:"颐安中台",
                labellv:"短信通知",
                names:"待开始",
                times:"2021	.10.12 18:00",
                },{
                name: '赠送活动',
                number:"活跃人群",
                xmember:"单次计划",
                lmember:"颐安中台",
                labellv:"短信通知",
                names:"待开始",
                times:"2021	.10.12 18:00",
            },],
        }
    },
    components:{
        memberGroup
    },
    methods:{
        copyGroup(obj){
            console.log(obj);
            this.$router.push({name:"newMarketingPlan"})
        },
        newPlan(){
            this.$router.push({name:"newMarketingPlan",query:{id:"111"}})
        },
        goReport(){
            this.$router.push({name:"dataReport",query:{id:"111"}})
        },
        doload(){

        },
        chageS(item){
            
        },
        goDetail(){
            this.$router.push({name:"crowdDetails",query:{id:1}})
        },
        showFz(type){
            this.$refs.memberGroup.show({type});
        }
    }
}
</script>
<style lang="less" scoped>
    .crowdMarketing{
        .f2{
                display: flex;
                justify-content: space-between;
                .li{
                    width:18%;
                    box-sizing: border-box;
                    background: #fff;
                    border-radius: 10px;
                    div{
                        &:first-child{
                            box-sizing: border-box;
                            height:100px;
                            background: url('../../assets/images/newIcon/group_recommend_bc.png') no-repeat;
                            padding:0px 15px;
                            padding-top:20px;
                            margin:0 10px;
                            margin-top:15px;
                            background-size:100% 100%;
                            color:#fff;
                            p{
                                &:first-child{
                                    margin-bottom:10px;
                                    font-size: 16px;
                                    font-weight: 500;
                                    color: #FFFFFF;
                                }
                                &:last-child{
                                    font-size: 12px;
                                    font-weight: 400;
                                    color: #FFFFFF;
                                }
                            }
                        }
                        &:nth-child(2){
                            display: flex;
                            margin:20px 0;
                            p{
                                width:50%;
                                text-align: center;
                                span{
                                    display: block;
                                    font-size: 12px;
                                    font-weight: 400;
                                    color: #666666;
                                    &:first-child{
                                        margin-bottom:10px;
                                        font-size: 20px;
                                        font-weight: bold;
                                        color: #327EFF;
                                    }
                                }
                            }
                        }
                        &:nth-child(3){
                            display: flex;
                            border-top:1px solid #EDEDED;
                            p{
                                &:first-child{
                                    border-right:1px solid #ededed;
                                }
                                padding:15px;
                                width:100%;
                                text-align: center;
                                img{
                                    margin-right:10px;
                                    width:16px;
                                    height:16px;
                                    vertical-align: middle;
                                }
                                span{
                                    font-size: 12px;
                                    font-weight: 400;
                                    color: #3285F8;
                                }
                            }
                        }
                    }
                }
        }
        .f3{
             .el-form{
                 padding:30px 15px;
                 padding-bottom:15px;
             }
            /deep/ .el-form-item{
                display: flex;
                align-items: center;
            }
            //  padding:30px;
           /deep/ .el-col-3{
               width:15.5%;
           }
           /deep/ .el-col-6{
               width:26%;
           }
            .icons{
                padding: 2px;
                margin-left:10px;
                color: rgb(255, 255, 255);
                background: rgb(46, 108, 246);
                border-radius: 50%;
            }
            .reson.el-button{
                background: #2E6CF6;
            }
           
            .times.el-input__inner{
                border-radius: 30px;
                width:100%;
                height:38px;
                .el-range-separator{
                    font-size:16px;
                    color:#ccc;
                    line-height: 28px;
                }
            }
            /deep/ .formItem.el-form-item{
                width:100%;
            }
            /deep/ .el-select{
                width: 100%;
            }
            /deep/ .formItem2  .el-form-item__content{
                // width:66%;
            }
            /deep/ .el-form-item__content{
                width:calc(100% - 100px);
            }
        }
        .f3{
            background: #fff;
        }
    }
    
    /deep/ .el-range-editor--mini .el-range-separator{
        font-size: 16px;
        color: #ccc;
        line-height: 28px;
    }
     /deep/ .iptRdio .el-input__inner{
        border-radius: 30px;
        height:38px;
    }
     /deep/ .iptRdio  .el-input__inner{
        background: #F6F6F6;
    }
    .dialog-footer{
            display: block;
            .el-button{
                border-radius: 30px;
            }
    }
    /deep/ .el-checkbox__inner{
        border-radius: 10px;
    }
   
    .title{
        display: flex;
        justify-content: space-between;
        p{
            font-size: 16px;
            font-weight: 500;
            color: #333940;
            img{
                margin-right:10px;
                width:20px;
                height:20px;
                vertical-align: middle;
                &:last-child{
                    margin-left:10px;
                    width:78px;
                    height:20px;
                }
            }
            &:last-child{
                span{
                    color: #0091FF;
                }
            }
            
        }
    }
</style>